export const isBlank = (text: string) => text.trim().length === 0